import { render } from "./ProjectsView.vue?vue&type=template&id=1c4916b6"
import script from "./ProjectsView.vue?vue&type=script&lang=js"
export * from "./ProjectsView.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/gradbeni-dnevnik/gradbeni-dnevnik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__